import { createAction, props } from '@ngrx/store';
import { Resoluciones } from 'src/app/models/pelicula.model';

export const cargaRes= createAction(
  '[RESOLUCIONES] Carga',
  props<{ resoluciones: Resoluciones[] }>()
  );
export const limpiaRes = createAction('[RESOLUCIONES] Remueve');
